exports = module.exports = require("./../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pager {\n  margin-top: 10px;\n  padding: 0;\n  font-size: 14px;\n}\n\n.pager li {\n  display: inline-block;\n}\n\nli.prev.pager-hide a,\nli.next.pager-hide a {\n  color: #999;\n  border-color: #999;\n}\n.pager li.active a {\n  font-weight: bold;\n  border-color: #ddd;\n}\n.pager li a {\n  text-decoration: none;\n  border-radius: 3px;\n  padding: 3px 8px;\n  margin: 0 2px;\n  color: #444;\n}\n\n.pager li.prev a,\n.pager li.next a{\n  font-weight: bolder;\n  border: 1px solid #eee;\n}\n\n\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/component-pager/pager.css
 ** module id = 8
 ** module chunks = 0
 **/